import translate from 'utils/apa/translations';

export const getLabels = () => {
  const title = translate('profile_public_profile_title', 'Perfil público');
  const subTitleOn = translate(
    'profile_public_profile_subtitle_status_on',
    'Activa esta opción para que tu perfil no pueda ser visto por los demás usuarios.',
  );
  const subTitleOff = translate(
    'profile_public_profile_subtitle_status_off',
    'Activa esta opción para que tu perfil no pueda ser visto por los demás usuarios.',
  );

  return {
    title,
    subTitleOn,
    subTitleOff,
  };
};

export const getMessage = ({ code, message }) => translate(code, message);
